const s = {
  name: "UsersBaggage",
  dimensions: { width: 38, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 40" style="enable-background:new 0 0 38 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,8c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8c0,4.4-3.6,8-8,8C13.6,16,10,12.4,10,8z M18,2c-3.3,0-6,2.7-6,6
			s2.7,6,6,6s6-2.7,6-6S21.3,2,18,2z"/>
		<path class="st0" d="M0,29c0-6.1,4.9-11,11-11h7v2h-7c-5,0-9,4-9,9v11H0V29z"/>
		<path class="st0" d="M6,30v10h2V30H6z"/>
		<path class="st0" d="M22,24h-3c-1.7,0-3,1.3-3,3v10c0,1.7,1.3,3,3,3h16c1.7,0,3-1.3,3-3V27c0-1.7-1.3-3-3-3h-3v-1c0-1.7-1.3-3-3-3
			h-4c-1.7,0-3,1.3-3,3V24z M19,26h1v12h-1c-0.6,0-1-0.4-1-1V27C18,26.4,18.4,26,19,26z M32,38H22V26h10V38z M34,38V26h1
			c0.6,0,1,0.4,1,1v10c0,0.6-0.4,1-1,1H34z M24,24v-1c0-0.5,0.5-1,1-1h4c0.5,0,1,0.5,1,1v1H24z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UsersBaggage
};
